import { useContext, useEffect, useState } from "react";
import DBTab from "../../../../component/global/DBTab";
import { useRequest } from "../../../../hooks/helperData/useRequest";
import { SETTING_ITEMS_TYPE_FAETURES } from "../../../../helperData/ApiAddress";
import { t } from "i18next";
import "./styles.scss";
import DBSpinner from "../../../../component/global/DBSpinner";
import {
    featureTypeList,
    getLanguageCaption,
} from "../../../../feedback/helperFunctions";
import DBTable from "../../../../component/global/DBTable/DBTable";
import { Add, Edit, SearchNormal, SearchNormal1, Trash } from "iconsax-react";
import DBPagination from "../../../../component/global/DBPagination";
import DBSwitch from "../../../../component/global/DBSwitch";
import DBButton from "../../../../component/global/DBButton";
import DBAddButton from "../../../../component/global/DBAddButton";
import DBInput from "../../../../component/global/DBInput";
import FeaturesModal from "./FeaturesModal";
import DBConfirmModal from "./../../../../component/global/DBConfirmModal/index";
import { ToastContext } from "../../../../component/global/ToastContext";

export default function FeaturesTab({ itemtype }) {
    const toast = useContext(ToastContext);

    const [getFeatures, getFeaturesLoader, cancelGetFeatures] = useRequest(
        SETTING_ITEMS_TYPE_FAETURES,
        "GET"
    );
    const [features, setFeatures] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [featuresModalShow, setFeaturesModalShow] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [searchStr, setSearchStr] = useState("");
    const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);

    const [deleteFeatures, deleteFeaturesLoader] = useRequest(
        SETTING_ITEMS_TYPE_FAETURES + deleteConfirmModal,
        "DELETE"
    );

    const getFeaturesHandle = () => {
        getFeatures({
            item_type: itemtype.id,
            page: currentPage,
            name: searchStr,
        }).then((r) => {
            setFeatures(r.results);
        });
    };

    useEffect(() => {
        if (itemtype) {
            cancelGetFeatures?.();
            getFeaturesHandle();
        }
    }, [itemtype, currentPage]);

    const [showToAllUpdate, showToAllUpdateLoader] = useRequest(
        SETTING_ITEMS_TYPE_FAETURES,
        "PATCH"
    );

    const showToAllHandle = (id) => {
        const newValue = !features.find((item) => item.id === id)?.show_to_all;
        showToAllUpdate({ show_to_all: newValue }, undefined, id).then((r) => {
            setFeatures(
                features.map((item) =>
                    item.id === id ? { ...item, show_to_all: newValue } : item
                )
            );
        });
    };

    const headers = [
        {
            id: "row",
            title: t("feature.row"),
            gridTemplateColumns: "60px",
        },
        {
            id: "name",
            title: t("feature.name"),
            gridTemplateColumns: "3fr",
        },
        {
            id: "language",
            title: t("feature.language"),
            gridTemplateColumns: "1fr",
        },
        {
            id: "type",
            title: t("feature.type"),
            gridTemplateColumns: "1fr",
        },
        {
            id: "weight",
            title: t("feature.weight"),
            gridTemplateColumns: "100px",
        },
        {
            id: "show",
            title: t("feature.show"),
            gridTemplateColumns: "100px",
        },
        {
            id: "options",
            title: t("feature.options"),
            gridTemplateColumns: "75px",
        },
    ];

    const rows = features?.map((item, index) => {
        return {
            row: index + 1,
            name: item.name,
            language: getLanguageCaption(item.language),
            type: featureTypeList[item.feature_type],
            weight: item.show_priority,
            show: (
                <div>
                    <DBSwitch
                        checked={item.show_to_all}
                        onChange={() => showToAllHandle(item.id)}
                        loading={showToAllUpdateLoader}
                    />
                </div>
            ),
            options: (
                <div className="option-buttons">
                    <Edit
                        size="18"
                        color="#2e71fc"
                        onClick={() => {
                            setEditMode(item.id);
                            setFeaturesModalShow(true);
                        }}
                    />
                    <Trash
                        size="18"
                        color="red"
                        onClick={() => setDeleteConfirmModal(item.id)}
                    />
                </div>
            ),
        };
    });

    const deleteFeaturesHandle = (_, id) => {
        console.log(id);
        deleteFeatures(undefined, [{ name: "id", value: id }])
            .then((r) => {
                toast(t("feature.deleted"), "success");
                setDeleteConfirmModal(false);
                getFeaturesHandle();
            })
            .catch((e) => {
                toast(t("feature.delete.error"), "danger");
            });
    };

    return (
        <div className="features-tab">
            <DBConfirmModal
                show={deleteConfirmModal}
                onHide={() => setDeleteConfirmModal(false)}
                btnTitle={t("features.delete")}
                onConfirm={deleteFeaturesHandle}
                title={t("features.delete")}
                description={t("features.delete.message")}
                loading={deleteFeaturesLoader}
            />
            <FeaturesModal
                showModal={featuresModalShow}
                onHide={() => setFeaturesModalShow(false)}
                itemType={itemtype}
                onSuccess={getFeaturesHandle}
                editMode={editMode}
            />
            <div className="features-toolbar">
                <div>
                    <DBInput
                        size="large"
                        placeholder={t("features.search")}
                        type="search"
                        allowClear
                        disabled={!itemtype}
                        onChange={(e) => {
                            setSearchStr(e.target.value);
                        }}
                        onPressEnter={getFeaturesHandle}
                    />
                    <DBAddButton
                        icon={<SearchNormal1 size={18} color="#2e71fc" />}
                        disabled={!itemtype}
                        onClick={getFeaturesHandle}
                    />
                </div>
                <div>
                    <DBButton
                        caption={
                            <>
                                <Add />
                                <span>{t("settings.add")}</span>
                            </>
                        }
                        outlined
                        disabled={!itemtype}
                        onClick={() => {
                            setEditMode(false);
                            setFeaturesModalShow(true);
                        }}
                    />
                </div>
            </div>
            <div className="features-table">
                {!itemtype ? (
                    <div className="not-itemtype">
                        {t("features.not.itemtype")}
                    </div>
                ) : getFeaturesLoader ? (
                    <DBSpinner tip={t("loading")} />
                ) : features.length === 0 ? (
                    <div className="not-itemtype">{t("features.empty")}</div>
                ) : (
                    <DBTable minWidth={700} headers={headers} rows={rows} />
                )}
            </div>
            <div className="features-pagination">
                <DBPagination
                    total={features.length}
                    onChange={(page) => {
                        setCurrentPage(page);
                    }}
                    current={currentPage}
                />
            </div>
        </div>
    );
}
